import { useTranslation } from 'react-i18next';
import { Switch } from '../../../../_uiComponents';
import { TabSettingsProps } from '../../../PricingModelTabContent.utils';
import styles from '../ContractContentV2.module.scss';

export const InvoiceTabSettingsV2 = ({ pricingModelTab, updatePricingModelData }: TabSettingsProps) => {
	const { t } = useTranslation('translation');

	return (
		<div className={styles.settingsBarContainer}>
			<span className={styles.settingsBarTitle}>{t('billingSettings')}</span>

			<div className={styles.settingsBarContent}>
				{/* Separate Invoice is the inverse of isCollective (ON === Collective OFF). */}
				<div className={styles.collectiveButton}>
					Separate Invoice
					<Switch
						smallSize
						onChange={(separateInvoice: boolean) =>
							updatePricingModelData(
								{
									...pricingModelTab,
									isCollective: !separateInvoice,
								},
								true,
							)
						}
						defaultChecked={pricingModelTab?.isCollective === false}
					/>
				</div>
			</div>
		</div>
	);
};
